import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const UserAPI = {
	list: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getById: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},

	create: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Users",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	update: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Users/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	delete: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Users/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	resetPassword: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Users/ResetPassword?userName=" + data.userName,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	// L'utente collegato cambia la propria password: {userName, oldPassword, newPassword}
	changePassword: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Users/ChangePassword",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	setLock: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Users/SetUserLock",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	setApproved: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Users/SetUserApproved",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getUserRosters: async (userId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users/UserRosters/" + userId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	setUserRosters: async (userId, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Users/UserRosters/" + userId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	// Override permessi-area diretti dell'utente (spesso []: eredita dal ruolo)
	getUserPermissions: async (userId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users/UserPermissions/" + userId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	// Permessi-area di base del ruolo (default ereditati dagli utenti del ruolo)
	getRolePermissions: async (roleId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users/RolePermissions/" + roleId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getRoleDefaults: async (roleName) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Users/RoleDefaults/" + encodeURIComponent(roleName),
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});
		return response.data;
	},
	// PUT bulk atomico: `data` è l'array nudo [{area, accessLevel}] che
	// SOSTITUISCE l'intero set (aree assenti = rimosse; [] = azzera).
	setUserPermissions: async (userId, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Users/UserPermissions/" + userId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	setRolePermissions: async (roleId, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Users/RolePermissions/" + roleId,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
};
